import Items from '../views/items/Index.vue';
import { checkauth } from '../Helper';

// inserimento, modifica e duplicazione sono pagine: tornando indietro la lista riparte dal suo URL
const ItemCreate = () => import('../views/items/Create.vue');
const ItemEdit = () => import('../views/items/Edit.vue');
// Amazon / eBay della scheda prodotto: pagine invece delle finestre a tutto schermo
const ItemMarketplace = () => import('../views/items/Marketplace.vue');
// Unisci / Acquisti / Vendite / Statistiche della variante (?sku=): pagine invece delle finestre a tutto schermo
const ItemVariantTool = () => import('../views/items/VariantTool.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/items',
		name: 'items',
		component: Items,
		beforeEnter: auth,
	},
	{
		path: '/items/new',
		name: 'item-new',
		component: ItemCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id del prodotto (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/items/:id([0-9a-fA-F]{24})',
		name: 'item-edit',
		component: ItemEdit,
		beforeEnter: auth,
	},
	{
		path: '/items/:id([0-9a-fA-F]{24})/duplicate',
		name: 'item-duplicate',
		component: ItemEdit,
		props: { duplicate: true },
		beforeEnter: auth,
	},
	{
		path: '/items/:id([0-9a-fA-F]{24})/marketplace/:platform(amazon|ebay)',
		name: 'item-marketplace',
		component: ItemMarketplace,
		beforeEnter: auth,
	},
	{
		path: '/items/:id([0-9a-fA-F]{24})/:tool(join|purchases|sales|stats)',
		name: 'item-variant-tool',
		component: ItemVariantTool,
		props: route => ({ tool: route.params.tool }),
		beforeEnter: auth,
	},
];
